import {
  BadgeDollarSign,
  Banknote,
  Coins,
  HandCoins,
  RefreshCw,
  Shield,
  Skull,
  Swords,
  type LucideIcon
} from "lucide-react";
import type { ActionType, Role } from "./types";

export const ROLES: Record<
  Role,
  { name: string; epithet: string; ability: string; blocks: string; color: string; sigil: string; image: string }
> = {
  Regent: {
    name: "Duke",
    epithet: "Greedy. Legitimately?",
    ability: "Tax: +3 Coins",
    blocks: "Blocks Foreign Aid",
    color: "#f5b82e",
    sigil: "R",
    image: "/assets/roles/regent.webp"
  },
  Knife: {
    name: "Assassin",
    epithet: "Quiet, please.",
    ability: "Assassinate: 3 Coins",
    blocks: "No block",
    color: "#ff5d50",
    sigil: "K",
    image: "/assets/roles/knife.webp"
  },
  Corsair: {
    name: "Captain",
    epithet: "Your coins. Their coins.",
    ability: "Steal: up to 2",
    blocks: "Blocks Steal",
    color: "#2d8cff",
    sigil: "C",
    image: "/assets/roles/corsair.webp"
  },
  Envoy: {
    name: "Ambassador",
    epithet: "Pick a face. Any face.",
    ability: "Draw 2, return 2",
    blocks: "Blocks Steal",
    color: "#b9e532",
    sigil: "E",
    image: "/assets/roles/envoy.webp"
  },
  Sentinel: {
    name: "Contessa",
    epithet: "Not getting past them.",
    ability: "No action",
    blocks: "Blocks Assassinate",
    color: "#a97af0",
    sigil: "S",
    image: "/assets/roles/sentinel.webp"
  }
};

export const ACTIONS: Record<
  ActionType,
  {
    name: string;
    short: string;
    detail: string;
    role: Role | null;
    target: boolean;
    icon: LucideIcon;
  }
> = {
  allowance: {
    name: "Income",
    short: "+1",
    detail: "Take 1 Coin. Safe and unblockable.",
    role: null,
    target: false,
    icon: Coins
  },
  patronage: {
    name: "Foreign Aid",
    short: "+2",
    detail: "Take 2 Coins. A Duke may block.",
    role: null,
    target: false,
    icon: HandCoins
  },
  banish: {
    name: "Coup",
    short: "7",
    detail: "Pay 7 Coins. A rival loses Influence.",
    role: null,
    target: true,
    icon: Skull
  },
  levy: {
    name: "Tax",
    short: "+3",
    detail: "Claim Duke and take 3 Coins.",
    role: "Regent",
    target: false,
    icon: BadgeDollarSign
  },
  silence: {
    name: "Assassinate",
    short: "3",
    detail: "Claim Assassin. Pay 3. Rival loses 1 Influence.",
    role: "Knife",
    target: true,
    icon: Swords
  },
  seize: {
    name: "Steal",
    short: "+2",
    detail: "Claim Captain. Take up to 2 Coins.",
    role: "Corsair",
    target: true,
    icon: Banknote
  },
  exchange: {
    name: "Exchange",
    short: "↺",
    detail: "Claim Ambassador. Draw 2, return 2.",
    role: "Envoy",
    target: false,
    icon: RefreshCw
  }
};

export const BLOCK_ICON = Shield;
